

















import { defineComponent, ref, computed } from '@nuxtjs/composition-api';
import { useCartItemCount } from '~/features/cart';
import { useProductContext, useProductGiftWrappingContext } from '~/features/productContext';

export default defineComponent({
  setup() {
    const isUpdating = ref(false);
    const { product } = useProductContext();
    const { giftWrappingComment } = useProductGiftWrappingContext();
    const { cartItemCount, item } = useCartItemCount(computed(() => product?.value?.sku || ''));

    return {
      isUpdating,
      giftWrappingComment,
      cartItemCount,
      item,
    };
  },
});
